module.exports = __webpack_public_path__ + "img/logo-white.87d3f4b9.png";